import { IEvolution } from '../../model/Tournament/ITournamentEvolution';

export const sortedEvolutionsByMostRecentDate = (evolutions: IEvolution[]) => {
    return evolutions.sort((a: IEvolution, b: IEvolution) => a.date < b.date ? 1 : -1);
};
